import * as React from 'react';
import Button from '@mui/material/Button';
import { useState, useEffect, useContext } from "react";
import "./style.module.scss"


export default function ButtonGroup({ handleSelected, options, title, defaultFiltered, ...props }) {

  const [completo, setCompleto] = useState([]);
  const arr = options.map(object => object.label);
  const [flag, setFlag] = React.useState([]);

  useEffect(() => {
    if (Object.keys(defaultFiltered).length != 0) {

      if (defaultFiltered == 'FINALIZADOS *') {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      }
      else if (defaultFiltered == 'TOTAL EM ABERTO') {
        setFlag(['Em Aberto']);
        setCompleto([{ id: 'Em Aberto', label: 'Em Aberto' }]);
      }
      else if (defaultFiltered == 'ACORDOS EM ANDAMENTO') {
        setFlag(['Em Acordo']);
        setCompleto([{ id: 'Em Aberto', label: 'Em Aberto' }]);
      }
      else if (defaultFiltered == 'BAIXA - PGTO DIRETO') {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      }
      else if (defaultFiltered == 'BAIXA - PDD') {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      }
      else if (defaultFiltered == 'BAIXA - AJUIZAMENTO') {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      }
      else if (defaultFiltered == 'BAIXA - RECUPERAÇÃO JUDICIAL') {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      } else {
        setFlag(['Finalizado']);
        setCompleto([{ id: 'Finalizado', label: 'Finalizado' }]);
      }
    }

  }) // <-- empty dependency array

  const handleClick = (e) => {
    let boolean = 0;
    if (!arr1) {
      var arr1 = []
    }

    arr1 = flag
    if (arr1.length == 0) {
      arr1.push(e)
    } else {
      boolean = 1

      arr1.forEach((element, index) => {

        if (element == e) {
          delete arr1[index]
          boolean = 0
        }

      });
      if (boolean == 1) { arr1.push(e) }
    }
    setFlag(arr1);
  };

  const filterArr = (e) => {
    let boolean = 0;
    if (!arr2) {
      var arr2 = []
    }
    arr2 = completo

    if (Object.keys(arr2).length == 0) {
      arr2.push({ id: e, label: e })
    } else {

      boolean = 1
      arr2.forEach((element, index) => {

        if (element.id == e) {
          delete arr2[index]
          boolean = 0
        }

      });
      if (boolean == 1) { arr2.push({ id: e, label: e }) }
    }

    setCompleto(arr2)
    handleSelected(arr2);
  }
  arr.sort(function(a, b){
    return b.length - a.length;
  });
  return (
    <>
      <p style={{ fontSize: '12px', marginBottom: '2px', color: '#2C4992', weight: '400', font:'roboto' }}>{title}</p>

      {arr.map((e, i) => {
        return (

            <Button
              size="small"
              style={{ fontSize: '10px',height:'24px', marginRight:'6px', marginTop:'6px' }}
              variant="contained"
              color={flag.includes(e) ? "blueOcean" : "primary"}
              onClick={() => { filterArr(e); handleClick(e) }}
              {...props}
            >{e.substring(0, 20)}</Button>


        )
      })
      }


    </>
  );
}